import { useDataTableUsingState, } from '@juvare/common-data-table-ui/DataTable';
import { FiltersBar } from '@juvare/common-data-table-ui/FiltersBar';
import { maxUrlSearchLength } from '@juvare/contact-management/utils/constants';
import React from 'react';
import { useArchivedFileColumns } from './useArchivedFileColumns';
import { mapFileFilter, useFileList } from './useFileList';
import { useFilesFilterConfig } from './useFilesFilterConfig';
export function useArchivedFileTable({ useDataTableFunction = useDataTableUsingState, defaultPermissions, currentDirectoryId, navigate, staticFilterData, }) {
    const params = {
        useDataProvider: (request) => useFileList(request, mapFileFilter, staticFilterData, currentDirectoryId),
        defaultRowsPerPage: 100,
        defaultSortColumnKey: 'name',
        maxUrlSearchLength,
        onRowClick: () => undefined,
    };
    const { dataTableProps, filtersBarProps, appliedFilterData, clearActiveRow, reload, setSelectedRowIds, setActiveRowId } = useDataTableFunction(params);
    const filterConfig = useFilesFilterConfig();
    return {
        dataTableProps: Object.assign(Object.assign({}, dataTableProps), { columns: useArchivedFileColumns({
                defaultPermissions,
                clearActiveRow,
                navigate,
                reload,
            }), filtersBar: React.createElement(FiltersBar, Object.assign({}, filtersBarProps, { config: filterConfig })), tableSx: { tableLayout: 'fixed' } }),
        filtersBarProps,
        appliedFilterData,
        clearActiveRow,
        setActiveRowId,
        setSelectedRowIds,
        reload,
    };
}
